module.exports = __webpack_public_path__ + "img/hatch__logo.bf4c32ad.png";